import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  bookingRollOutMarketList: {},
  isLoading: false,
  error: "",
  hasData: false,
  bookingRollOutMarketStatus: {
    status: false,
    message: ""
  }
};
const bookingRollOutMarketListSlice = createSlice({
  name: "bookingMarketRollout",
  initialState,
  reducers: {
    bookingRollOutListRequest: state => {
      state.isLoading = true;
    },
    bookingRollOutListSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.bookingRollOutMarketList = action.payload;
      state.bookingRollOutMarketStatus = true;
    },
    bookingRollOutListFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.bookingRollOutMarketStatus = false;
    }
  }
});
export const {
  bookingRollOutListRequest,
  bookingRollOutListSuccess,
  bookingRollOutListFailure
} = bookingRollOutMarketListSlice.actions;
export default bookingRollOutMarketListSlice.reducer;